import API from "@/api";

export const moduleName = "payments";

export const actionTypes = {
  ACTION_LOAD_PAYMENTS: "ACTION_LOAD_PAYMENTS",
};

export const getterTypes = {
  GETTER_PAYMENTS: "GETTER_PAYMENTS",
  GETTER_PAYMENTS_COUNT: 'GETTER_PAYMENTS_COUNT',
  GETTER_CHECKED_ROWS: 'GETTER_CHECKED_ROWS',
};

export const mutationTypes = {
  SET_PAYMENTS_DATA: "SET_PAYMENTS_DATA",
  SET_CHECKED_ROW: 'SET_CHECKED_ROW',
  SET_CHECKED_ROWS: 'SET_CHECKED_ROWS',
  UNSET_CHECKED_ROWS: 'UNSET_CHECKED_ROWS',
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    checkedPaymentTableRows: [],
    payments: [],
    paymentsCount: 0
  }),

  actions: {
    async [actionTypes.ACTION_LOAD_PAYMENTS]({ commit }, payload) {
      const response = await API.paymentsManager.loadPayments(payload);
      const { payments, paymentsCount } = response.data;
      commit(mutationTypes.SET_PAYMENTS_DATA, [payments, paymentsCount]);
    },
  },

  mutations: {
    [mutationTypes.UNSET_CHECKED_ROWS] (state) {
      state.checkedPaymentTableRows = []
    },
    [mutationTypes.SET_PAYMENTS_DATA](state, [payments, paymentsCount]) {
      if (Array.isArray(payments)) {
        state.payments = payments;
      }
      if (!isNaN(paymentsCount)) {
        state.paymentsCount = paymentsCount;
      }
    },
    [mutationTypes.UNSET_CHECKED_ROWS] (state) {
      state.checkedPaymentTableRows = []
    },
    [mutationTypes.SET_CHECKED_ROW] (state, row) {
      const targetIndex = state.checkedPaymentTableRows.indexOf(row)
      if (targetIndex >= 0) {
        state.checkedPaymentTableRows.splice(targetIndex, 1)
      } else {
        state.checkedPaymentTableRows.push(row)
      }
    },
    [mutationTypes.SET_CHECKED_ROWS] (state, rows) {
      if (state.checkedPaymentTableRows.length > 0 && state.checkedPaymentTableRows.every(row => rows.includes(row))) {
        state.checkedPaymentTableRows = []
      } else {
        state.checkedPaymentTableRows = [...rows]
      }
    },
  },

  getters: {
    [getterTypes.GETTER_PAYMENTS]: state => state.payments,
    [getterTypes.GETTER_PAYMENTS_COUNT]: (state) => state.paymentsCount,
    [getterTypes.GETTER_CHECKED_ROWS]: (state) => state.checkedPaymentTableRows,
  }
};
